import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

const IMAGES = {
  materials: 'https://customer-assets.emergentagent.com/job_a76be86f-7fd5-4574-bb32-409e5b263642/artifacts/89m8g65e_galvanized-vs-epoxy-coated-rebar-comparison-1024x585.jpg',
  infrastructure: 'https://customer-assets.emergentagent.com/job_a76be86f-7fd5-4574-bb32-409e5b263642/artifacts/0f62byna_image.png',
  digital: 'https://static.prod-images.emergentagent.com/jobs/a76be86f-7fd5-4574-bb32-409e5b263642/images/0f0fe63f43e6bc84e4dfdb9e3b7e28eb57edf6f16abfdd01de7f27a46d9c914c.png',
};

export const Studios = () => {
  const { t } = useTranslation();
  const studios = [
    { title: t('eng_v2.materials_title'), desc: t('eng_v2.materials_desc'), path: '/engineering/services/materials', tag: 'Materials', image: IMAGES.materials },
    { title: t('eng_v2.infrastructure_title'), desc: t('eng_v2.infrastructure_desc'), path: '/engineering/services/infrastructure-risk', tag: 'Risk', image: IMAGES.infrastructure },
    { title: t('eng_v2.digital_title'), desc: t('eng_v2.digital_desc'), path: '/engineering/services/digital', tag: 'Digital', image: IMAGES.digital },
  ];

  return (
    <div className="min-h-screen pt-16" style={{fontFamily:'IBM Plex Sans,sans-serif'}}>
      <SEO title={`${t('services.page_title')} | Durable Designs`} path="/engineering/services" />
      <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden" style={{ background: '#06120B' }}>
        <div className="max-w-7xl mx-auto relative z-10">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tighter mb-4" style={{fontFamily:'Plus Jakarta Sans,sans-serif'}} data-testid="studios-heading">{t('services.page_title')}</h1>
          <p className="text-base text-neutral-400 max-w-2xl">{t('eng_v2.services_subtitle')}</p>
        </div>
      </section>
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto"><div className="space-y-8">
          {studios.map((s, i) => (
            <Link key={s.path} to={s.path} className="group flex flex-col md:flex-row border border-gray-200 hover:border-emerald-500 transition-colors overflow-hidden" data-testid={`studio-link-${s.path.split('/').pop()}`}>
              <div className="md:w-1/3 h-56 md:h-auto overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="flex-1 p-8 md:p-12 flex flex-col justify-center">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 tracking-tight" style={{fontFamily:'Plus Jakarta Sans,sans-serif'}}>{s.title}</h2>
                <p className="text-base text-gray-500 mb-6 max-w-xl">{s.desc}</p>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-emerald-600 group-hover:text-emerald-500 transition-colors">{t('eng_v2.view_studio')} <ArrowRight className="w-4 h-4" /></span>
              </div>
            </Link>
          ))}
        </div></div>
      </section>
    </div>
  );
};
export default Studios;
